import React, {useState, useEffect} from "react";
import { useParams, Link } from "react-router-dom";
import {Tabs, Tab} from "react-bootstrap";
//import moment from "moment";
import "./../../../Public/css/tabler-icons.css";
import "./../../../Public/css/fontawesome.min.css";
import "./../../../Public/css/all.min.css";
import "./../../../Public/css/style.css";

import {getProfileInfoAPI, getStagePipelineAPI} from "./../../../API/Team/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
//import { ProfileContext } from "./ProfileContext";
import BasicProfile from "./Profile/BasicProfile";
import OtherProfile from "./Profile/OtherProfile";
import Notification from "./Profile/Notification";
import Remarks from "./Profile/Remarks";
import SendMail from "./Profile/SendMail";
import { ToastContainer } from "react-toastify";


const LeadProfile = () =>{

    const {leadid} = useParams();
    //const current = moment();

	//const [btnloading, setBtnLoading] = useState(false);
	const [activetabs, setActiveTabs] = useState("activities");
	const [pipeline, setPipeline] = useState([]);
	const [txtpipeline, setTxtPipeline] = useState("");
	//const [profiledata, setProfileData] = useState({basicinfo: null, otherinfo: null, remarks: [], notifications: []});
	const [basicinfo, setBasicInfo] = useState(null);
	const [otherinfo, setOtherInfo] = useState(null);
	const [notifications, setNotifications] = useState([]);
	const [remarks, setRemarks] = useState([]);
	const [pageloader, setPageLoader] = useState(true);
	const [ispipelinereload, setIsPipelineReload] = useState(false);
	

	useEffect(()=>{

		console.log('Reloas pipeline api');
		getStagePipelineAPI(setPipeline, setTxtPipeline, setIsPipelineReload, leadid);

	}, [ispipelinereload, leadid]);

    useEffect(()=>{

        //getProfileInfoAPI(setName, setEmail, setContact, setLocation, setStage, setDisposition, setSubDisposition, setOtherEmail, setOtherContact, setProgram, setInstitute, setSource, setCreatedDate, setLastUpdated, setRemarks, setPipeline, setNotifications, setTxtPipeline, leadid);

		//getProfileInfoAPI(setProfileData, setPipeline, setTxtPipeline, leadid);
		getProfileInfoAPI(setBasicInfo, setOtherInfo, setNotifications, setRemarks, setPipeline, setTxtPipeline, leadid, setPageLoader);

		console.log('pipeline lngth=====' + pipeline.length );

		//console.log('under basic profile=====' + JSON.stringify(profiledata));

    }, []);

	/*const reloadPipeline = React.useCallback(() => {
    	getStagePipelineAPI(setPipeline, setTxtPipeline, leadid);
	}, [leadid]);

	const providerValue = {
        profileid: leadid,
        profiledata,
        setProfileData,

        pipeline,
        txtpipeline,

        reloadPipeline,
    };*/


	//console.log("PROFILE DATA >>>", profiledata);

	if(pageloader) return <div>Profile Loading...</div>;

    return(
    <div className="main-wrapper">

		

        <Loader />

        <Header />

        <Sidebar />

		
        <div className="page-wrapper">
			<div className="content">

				<div className="row">
					<div className="col-md-12">

						<div className="page-header">
							<div className="row align-items-center">
								<div className="col-sm-4">
									<h4 className="page-title">Leads Overview </h4>
								</div>
								<div className="col-sm-8 text-sm-end">
									<div className="head-icons">
										
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div className="row">
					<div className="col-md-12">

						<div className="contact-head">
							<div className="row align-items-center">
								<div className="col-sm-6">
									<ul className="contact-breadcrumb">
										<li>
                                            <Link to="/team/leads">
                                                <i className="ti ti-arrow-narrow-left"></i>Back
                                            </Link>
                                        </li>
									</ul>
								</div>
								<div className="col-sm-6 text-sm-end">
									<div className="contact-pagination">
										
									</div>
								</div>
							</div>
						</div>
						<div className="card background-none">
							<div className="card-body pb-2">
                                <div class="row g-3">

									<BasicProfile profiledata={basicinfo} profileid={leadid}  />
                                
                                    <Notification profiledata={notifications} />
								</div>

							</div>
								
						</div>

					</div>

					<div className="col-xl-3 theiaStickySidebar">
        				<div className="card">
						<OtherProfile profiledata={otherinfo} profileid={leadid} />
						</div>
					</div>

					<div className="col-xl-9">

						<div className="card mb-3">
							<div className="card-body pb-0">
								{pipeline.length <= 0 ?
									(txtpipeline !== "" && txtpipeline !== null ?
										<>
										<h4 className="fw-semibold mb-3">Lead Pipeline Status</h4>
										<div className="pipeline-list">
											<ul>
												<li>
													<Link to="#" className={txtpipeline.name === 'Warm' ? "bg-pending" :
																			(txtpipeline.name === 'Contacted' ? "bg-contacted" :
																			(txtpipeline.name === 'Dead' ? "bg-dead" : 
																			(txtpipeline.name === 'Cold' ? "bg-cold" :
																			(txtpipeline.name === 'Attempt to Contact' ? "bg-attempt" :
																			(txtpipeline.name === 'Enrolled' ? "bg-enrolled" :
																			(txtpipeline.name === 'Duplicate' ? "bg-duplicate" :
																			(txtpipeline.name === 'Dropout' ? "bg-dropout" : "" )
																			)
																		)
																	)
																)
															)	
														)
													}>{txtpipeline?.name}</Link>
												</li>
											</ul>
										</div>
										</>
									:
										<></>
									)
								:
									<>
									<h4 className="fw-semibold mb-3">Lead Pipeline Status</h4>
									<div className="pipeline-list">
										<ul>
											{
												pipeline.map((pipeliedata, index)=>
												(
													<li key={index}>
														
														<Link to="#" className={pipeliedata.name === 'Warm' ? "bg-pending" :
																				(pipeliedata.name === 'Contacted' ? "bg-contacted" :
																				(pipeliedata.name === 'Dead' ? "bg-dead" : 
																				(pipeliedata.name === 'Cold' ? "bg-cold" :
																				(pipeliedata.name === 'Attempt to Contact' ? "bg-attempt" :
																				(pipeliedata.name === 'Enrolled' ? "bg-enrolled" :
																				(pipeliedata.name === 'Duplicate' ? "bg-duplicate" :
																				(pipeliedata.name === 'Dropout' ? "bg-dropout" : "" )
																				)
																			)
																		)
																	)
																)	
															)
														}>{pipeliedata.name}</Link>
													</li>	
												))
											}
											
										</ul>
									</div>
									</>
								}


								<ul className="nav nav-tabs nav-tabs-bottom" role="tablist">										
									<Tabs activeKey={activetabs} onSelect={(k) => setActiveTabs(k)} className="nav-tabs-bottom">
										<Tab eventKey="activities" title={<><i className="ti ti-alarm-minus me-1"></i> Activities</>}>
											
										</Tab>
										<Tab eventKey="email" title={<><i className="ti ti-mail-check me-1"></i>Email</>}>
											
										</Tab>
									</Tabs>
								</ul>
							</div>
						</div>

						<div className="tab-content pt-0">
							{ activetabs === 'activities' &&
								
								<Remarks profiledata={remarks} pipelineReloadStatus={() => setIsPipelineReload(prev => !prev)} profileid={leadid}  />
								
							}

							{ activetabs === 'email' &&
								
								<SendMail />
								
							}
						</div>
					</div>
				</div>
			</div>
		</div>
		<ToastContainer />
    </div>
    )
}

export default LeadProfile;